import R from 'ramda'

const OPT_IN_ACTION_TYPE = 'OPT_IN'
const OPT_IN_DISPLAY_TYPE = 'Opt user in'

const isOptInFormAction = R.propEq('type', OPT_IN_DISPLAY_TYPE)

const convertOptInFormActionToWidgetAction = R.applySpec({
  type: R.always(OPT_IN_ACTION_TYPE)
})

export { isOptInFormAction, convertOptInFormActionToWidgetAction }



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/actions/twitter/form-to-widget/opt-in.js